import React, { useContext, useEffect } from 'react';
import { trackViewEvent } from '../../../utils/omnitureUtils';
import RouteInfoContext from '../../route_info/RouteInfoContext';
import SpotlightSlider from '../SpotlightSlider/SpotlightSlider';
import '../../../styles/Spotlight.css';

type SpotlightType = {
  openModal: () => void;
};

const Spotlight = ({ openModal }: SpotlightType) => {
  const trainsData = useContext(RouteInfoContext);
  const busData = trainsData?.busSeoRoutes?.busGroups
    ?.find((busGroup) => busGroup.groupName === 'Private Buses')
    ?.buses?.splice(0, 3);

  const features = [
    {
      img: 'badgeImg',
      txt: 'Exciting offers'
    },
    {
      img: 'stopwatchImg',
      txt: ' Ontime performance'
    },
    {
      img: 'routeImg',
      txt: 'Point to Point'
    }
  ];

  useEffect(() => {
    trackViewEvent('trains_seo_route_cp_visible');
  }, []);

  return (
    <div className="exploreBusContainer">
      <div className="exploreBusHead">
        <h3>Explore buses for best-in-class amenities & services.</h3>
        {features.map((item, i) => {
          return (
            <div className="busOffers">
              <div className={item.img + ' busFeatureImg'} />
              <span>{item.txt}</span>
            </div>
          );
        })}
      </div>
      <div className="SliderCont">
        <div className="leftSlide" />
        <SpotlightSlider data={busData} />
        <div className="rightSlide" />
      </div>
      <div className="viewAllCta" onClick={openModal}>
        <span className="viewCtaTxt">View all</span>
        <div className="viewCtaArrow" />
      </div>
    </div>
  );
};

export default Spotlight;
